import * as React from 'react'

type UseMediaQueryProps = {
  query: string
}

export const useMediaQuery = ({ query }: UseMediaQueryProps): boolean => {
  const [matches, setMatches] = React.useState<boolean>(
    () => globalThis.window.matchMedia(query).matches ?? false
  )

  React.useEffect(() => {
    const media = globalThis.window.matchMedia(query)

    const listener = () => setMatches(media.matches)

    media.addEventListener('change', listener)
    return () => media.removeEventListener('change', listener)
  }, [query])

  return React.useMemo(() => matches, [matches])
}

type UseBreakpointResult = {
  isSm: boolean
  isMd: boolean
  isLg: boolean
  isXl: boolean
  is2Xl: boolean
}

export const useBreakpoint = (): UseBreakpointResult => {
  const isSm = useMediaQuery({ query: '(min-width: 640px)' })
  const isMd = useMediaQuery({ query: '(min-width: 768px)' })
  const isLg = useMediaQuery({ query: '(min-width: 1024px)' })
  const isXl = useMediaQuery({ query: '(min-width: 1280px)' })
  const is2Xl = useMediaQuery({ query: '(min-width: 1536px)' })

  return React.useMemo(
    () => ({ isSm, isMd, isLg, isXl, is2Xl }),
    [isSm, isMd, isLg, isXl, is2Xl]
  )
}
